export default __webpack_public_path__ + "static/media/(4).d0a21c72.jpg";